import PopUpConfirmation from './PopUpConfirmation';

export default PopUpConfirmation;
